import type { StaffRole } from '@ucp/web/lib';

/**
 * Every role holding `hr_case_work` (PRO-2010, ADR-080 / ADR-018). Mirrors the server
 * role→capability map; `L6_PLATFORM_ADMIN` is DELIBERATELY absent (EoP — never an HR
 * shortcut). A colleague reaches their own cases through Ask TAG, not this queue.
 *
 * Dependency-light so the route guard needs it synchronously without dragging the
 * lazy-loaded queue into the initial chunk.
 */
export const HR_CASE_ROLES: readonly StaffRole[] = ['HR_CASE_HANDLER', 'HR_CASE_LEAD'];
